export default "__VITE_ASSET__B8PxOPn2__"